//Creator_form Page
import React, { useEffect, useState } from "react";
import styles from "../../Styles/Creator_Form/styles.module.css";
import bubbles from "../../images/bubble.png";
import Basicinfo from "../../Components/createForm/basicinfo";
import ProInfo from "../../Components/createForm/proinfo";
import Confirm from "../../Components/createForm/confirm";
import bubble from "../../images/Ellipse 13.png";
import { createCreatorForm } from "../../helper/authApiCalls/auth";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import { useNavigate } from "react-router-dom";
import bubbles2 from "../../images/Bubbles (1).svg";

const CreatorForm = () => {
  const [menu, setMenu] = useState("basic");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    location: "",
    profession: "",
    statusCode: "",
    mobile: "",
    social: "",
    pptknowledge: "",
    pastexperiences: "",
    shortdescription: "",
    languages: [],
    relevantskills: "",
  });

  const handleChange = (name) => (e) => {
    e.preventDefault();
    setValues({ ...values, [name]: e.target.value });
  };

  function onSubmit() {
    setError("");
    setSuccess(false);

    const sendData = {
      name: values.name,
      email: values.email,
      location: values.location,
      profession: values.profession,
      mobile: values.statusCode + values.mobile,
      social: values.social,
      pptknowledge: values.pptknowledge,
      pastexperiences: values.pastexperiences,
      shortdescription: values.shortdescription,
      languages: values.languages,
      password: values.password,
      relevantskills: values.relevantskills,
    };

    createCreatorForm(sendData).then((data) => {
      console.log(data, "data from creator form");
      if (data.error) {
        setError(data.error);
      } else {
        setSuccess(true);
      }
    });
  }

  let navigate = useNavigate();

  const successComponent = () => {
    return (
      <div className={styles.success}>
        <div>
          <p>Your form has been submitted successfully.</p>
          <span>We will shortly review your form and get back to you</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (isAuthenticated()) {
      return navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CreatorFormPage = () => {
    return (
      <div className="creatorform">
        <div className={styles.mainbody}>
          <div className={styles.rightflank}>
            <div className={styles.fig}>
              <img src={bubbles} alt="%" />
            </div>

            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.downspans}>
              <div className={styles.upspan}>
                <span>Grow by learning</span>
                <img src={bubble} alt="" />
              </div>
              <div className={styles.downspan}>
                <span>
                  We strive to help and bring together the online learners
                  community by compiling knowledgeable resources from all over
                  the internet.
                </span>
              </div>
            </div>
          </div>
          <div className={styles.leftflank}>
            {!success ? (
              <div>
                <div className={styles.mainlog}>
                  <div className={styles.progressbar}>
                    <ul>
                      <li id="basic">
                        <div className={styles.active}>1</div>
                        <span>Basic</span>
                      </li>
                      <li id="second">
                        <div
                          className={
                            menu === "third" || menu === "second"
                              ? styles.active
                              : ""
                          }
                        >
                          2
                        </div>
                        <span>Proffesional</span>
                      </li>
                      <li id="third">
                        <div className={menu === "third" ? styles.active : ""}>
                          3
                        </div>
                        <span>Review</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={styles.in}>
                  {menu === "basic" && (
                    <Basicinfo
                      handleChange={handleChange}
                      values={values}
                      setMenu={setMenu}
                      setValues={setValues}
                    />
                  )}
                  {menu === "second" && (
                    <ProInfo
                      handleChange={handleChange}
                      values={values}
                      setMenu={setMenu}
                    />
                  )}
                  {menu === "third" && (
                    <Confirm
                      onSubmit={onSubmit}
                      values={values}
                      setMenu={setMenu}
                      error={error}
                    />
                  )}
                </div>
              </div>
            ) : (
              <div>{successComponent()}</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const CreatorFormMobile = () => {
    return (
      <div>
        <div className="creatorform">
          <div className={styles.creatorMob}>
            <div className={styles.bubblecontain}>
              <img src={bubbles2} alt="%" />
            </div>
            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.in}>
              {!success ? (
                <>
                  <div className={styles.progressMob}>
                    <ul>
                      <li id="basic">
                        <div className={styles.active}>1</div>
                        <span>Basic</span>
                      </li>
                      <li id="second">
                        <div
                          className={
                            menu === "third" || menu === "second"
                              ? styles.active
                              : ""
                          }
                        >
                          2
                        </div>
                        <span>Proffesional</span>
                      </li>
                      <li id="third">
                        <div className={menu === "third" ? styles.active : ""}>
                          3
                        </div>
                        <span>Review</span>
                      </li>
                    </ul>
                  </div>
                  <div className={styles.mainbodyMob}>
                    {menu === "basic" && (
                      <Basicinfo
                        handleChange={handleChange}
                        values={values}
                        setMenu={setMenu}
                        setValues={setValues}
                      />
                    )}
                    {menu === "second" && (
                      <ProInfo
                        handleChange={handleChange}
                        values={values}
                        setMenu={setMenu}
                      />
                    )}
                    {menu === "third" && (
                      <Confirm
                        onSubmit={onSubmit}
                        values={values}
                        setMenu={setMenu}
                        error={error}
                      />
                    )}
                  </div>
                </>
              ) : (
                <div>{successComponent()}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {CreatorFormPage()}
      {CreatorFormMobile()}
    </div>
  );
};

export default CreatorForm;
